import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import { CalendarEventsLoadingState } from 'owa-calendar-events-store';
import { Calendar } from 'owa-calendar-cache';

export const addLocalLieCalendar = mutatorAction(
    'ADD_LOCAL_LIE_CALENDAR',
    (calendar: Calendar, loadingState: CalendarEventsLoadingState) => {
        const store = getStore();
        store.calendars.push(calendar);
        store.calendarLoadingState.set(calendar.id.id, loadingState);
        store.localLieCalendarIds.set(calendar.id.id, true);
    }
);
